<template>
  <div>
    <!-- Haupt-Modal -->
    <div class="modal-overlay" v-if="show" @click.self="$emit('close')">
      <div class="modal-content" style="position: relative">
        <button 
          class="close-button" 
          :style="{ top: post.status === 'rejected' ? '40px' : '10px' }"
          @click="$emit('close')"
        >
          <i class="fas fa-times"></i>
        </button>
        <div v-show="post.status === 'rejected'" style="width: 100%; position: absolute; top: 0; left: 0; color: white; font-size: 14px; padding: 4px 0" :style="{'background-color': post.status === 'rejected' ? '#dc3545' : ''}">
          Beitrag in Korrektur
          <span v-if="post.status === 'rejected' && post.notes" class="info-icon" @mouseover="showNoteTooltip = true" @mouseleave="showNoteTooltip = false">
            <i class="fas fa-info-circle"></i>
            <span v-if="showNoteTooltip" class="tooltip">{{ post.notes }}</span>
          </span>
        </div>
        <div class="platform-switch">
          <button 
            class="platform-button"
            v-if="post.networks.includes('facebook')" 
            :class="{ active: isFacebook }"
            @click="switchPlatform('facebook')"
          >
            <i class="fab fa-facebook-f"></i>
          </button>
          <button 
            class="platform-button instagram-button"
            v-if="post.networks.includes('instagram')" 
            :class="{ active: isInstagram }"
            @click="switchPlatform('instagram')"
          >
            <i class="fab fa-instagram"></i>
          </button>
          <button 
            class="platform-button tiktok-button"
            v-if="post.networks.includes('tiktok')" 
            :class="{ active: isTikTok }"
            @click="switchPlatform('tiktok')"
          >
            <i class="fab fa-tiktok"></i>
          </button>
        </div>

        <div class="preview-container" :class="isInstagram ? 'instagram' : isTikTok ? 'tiktok' : 'facebook'">
          <!-- Instagram Layout -->
          <div v-if="isInstagram" class="instagram-post">
            <div class="post-header">
              <div class="profile-info">
                <img class="profile-pic" :src="user.metricoolUserData.instagramPicture" alt="Profilbild">
                <span class="username">{{ user.metricoolUserData.instagram }}</span>
              </div>
              <!-- <div class="more-options">•••</div> -->
            </div>
            
            <div class="post-content">
              <!-- Media Grid nur für Bilder -->
              <div v-if="Array.isArray(post.metricoolPost.media) && !hasVideos" class="media-container slideshow">
                <button class="slide-nav prev" @click="previousSlide" v-if="post.metricoolPost.media.length > 1">
                  <i class="fas fa-chevron-left"></i>
                </button>
                
                <div class="slide-container">
                  <img v-for="(mediaUrl, index) in post.metricoolPost.media" 
                       :key="index"
                       :src="mediaUrl"
                       :class="{ active: index === currentSlideIndex }"
                       alt="Post media">
                </div>
                
                <button class="slide-nav next" @click="nextSlide" v-if="post.metricoolPost.media.length > 1">
                  <i class="fas fa-chevron-right"></i>
                </button>
                
                <div class="slide-dots" v-if="post.metricoolPost.media.length > 1">
                  <span v-for="(_, index) in post.metricoolPost.media" 
                        :key="index" 
                        :class="{ active: index === currentSlideIndex }"
                        class="dot">
                  </span>
                </div>
              </div>

              <!-- Video wird separat angezeigt -->
              <div v-else-if="hasVideos" 
                   class="reel-container"
                   @mouseover="!isMobile && (showPlayButton = true)" 
                   @mouseleave="!isMobile && (showPlayButton = false)">
                <video 
                  ref="videoPlayer"
                  :src="firstVideo"
                  :poster="videoThumbnail"
                  style="width: 100%"
                  playsinline
                  webkit-playsinline
                  x5-playsinline
                  x5-video-player-type="h5"
                  x5-video-player-fullscreen="true"
                  preload="metadata"
                  crossorigin="anonymous"
                  @click.prevent
                  controls
                ></video>
                <div v-if="!isMobile && showPlayButton" class="play-pause-overlay" @click="togglePlay">
                  <div class="play-pause-button">
                    <i :class="isPlaying ? 'fas fa-pause' : 'fas fa-play'"></i>
                  </div>
                </div>
              </div>
              
              <div class="instagram-actions">
                <div class="action-row">
                  <div class="left-actions">
                    <button class="action-icon"><i class="far fa-heart"></i></button>
                    <button class="action-icon"><i class="far fa-comment"></i></button>
                    <button class="action-icon"><i class="far fa-paper-plane"></i></button>
                  </div>
                  <button class="action-icon bookmark"><i class="far fa-bookmark"></i></button>
                </div>
              </div>
              
              <div class="post-info">
                <div class="post-reference"><span class="username">{{ user.metricoolUserData.instagram }}</span> {{ post.text }}</div>
              </div>
            </div>
          </div>

          <!-- TikTok Layout -->
          <div v-else-if="isTikTok" class="tiktok-post">
            <div class="tiktok-content">
              <div class="tiktok-video-container"
                @mouseover="!isMobile && (showPlayButton = true)" 
                @mouseleave="!isMobile && (showPlayButton = false)"
              >
                <video 
                  ref="videoPlayer"
                  :src="post.mediaUrl" 
                  :poster="videoThumbnail"
                  playsinline
                  webkit-playsinline
                  x5-playsinline
                  x5-video-player-type="h5"
                  x5-video-player-fullscreen="true"
                  preload="metadata"
                  @click.prevent
                  controls
                  style="width: 100%; height: 100%; object-fit: cover;"
                ></video>
                
                <!-- Play/Pause Button nur für Desktop -->
                <div v-if="!isMobile && showPlayButton" class="play-pause-overlay" @click="togglePlay">
                  <div class="play-pause-button">
                    <i :class="isPlaying ? 'fas fa-pause' : 'fas fa-play'"></i>
                  </div>
                </div>

                <!-- TikTok Overlay Elements mit angepasstem z-index -->
                <div class="tiktok-overlay" :style="{ zIndex: isMobile ? '5' : '10' }">
                  <!-- Rechte Sidebar -->
                  <div class="tiktok-sidebar">
                    <div class="tiktok-action">
                      <i class="fas fa-heart"></i>
                      <span>0</span>
                    </div>
                    <div class="tiktok-action">
                      <i class="fas fa-comment-dots"></i>
                      <span>0</span>
                    </div>
                    <div class="tiktok-action">
                      <i class="fas fa-share"></i>
                      <span>0</span>
                    </div>
                  </div>

                  <!-- Unterer Bereich -->
                  <div class="tiktok-bottom">
                    <div class="tiktok-user-info">
                      <span class="tiktok-username">@{{ user.metricoolUserData.tiktok }}</span>
                    </div>
                    <div class="tiktok-description">
                      {{ post.text }}
                    </div>
                  </div>

                  <!-- Oberer Bereich -->
                  <div class="tiktok-top">
                    <div class="tiktok-tabs">
                      <span class="active">Folge ich</span>
                      <span>Für dich</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Facebook Layout -->
          <div v-else-if="isFacebook" class="facebook-post">
            <div class="post-header">
              <div class="profile-section">
                <img class="profile-pic" :src="user.metricoolUserData.facebookPicture" alt="Profilbild">
                <div class="header-text">
                  <div class="page-name">{{ user.metricoolUserData.facebook }}</div>
                  <div class="post-meta">
                    <span class="post-date">{{ formatDateTime(post.publicationDate.dateTime) }}</span>
                    <span class="dot">·</span>
                    <span class="globe-icon"><i class="fas fa-globe"></i></span>
                  </div>
                </div>
              </div>
              <!-- <div class="more-options">•••</div> -->
            </div>
            
            <div class="post-content">
              <div class="post-text">
                <div class="text-edit-container">
                  <div v-if="!isEditingText" class="text-display">
                    {{ post.text }}
                  </div>
                  <div v-else class="text-edit-form">
                    <textarea 
                      v-model="editedText"
                      class="text-edit-textarea"
                      rows="4"
                    ></textarea>
                    <div class="text-edit-actions">
                      <button class="text-edit-cancel" @click="cancelEditingText">
                        Abbrechen
                      </button>
                      <button 
                        class="text-edit-save" 
                        @click="saveEditedText"
                        :disabled="isSaving"
                      >
                        <span v-if="!isSaving">Speichern</span>
                        <span v-else class="loading-spinner"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Media Grid nur für Bilder -->
              <div v-if="Array.isArray(post.metricoolPost.media) && !hasVideos" 
                   class="media-grid"
                   :class="`grid-${post.metricoolPost.media.length}`"
              >
                <div v-for="(mediaUrl, index) in post.metricoolPost.media" 
                     :key="index" 
                     class="grid-item"
                     :class="{ 'large': post.metricoolPost.media.length === 1 }"
                >
                  <img :src="mediaUrl" alt="Post media">
                </div>
              </div>

              <!-- Video wird separat angezeigt -->
              <div v-else-if="hasVideos" 
                   class="reel-container"
                   @mouseover="!isMobile && (showPlayButton = true)" 
                   @mouseleave="!isMobile && (showPlayButton = false)">
                <video 
                  ref="videoPlayer"
                  :src="firstVideo"
                  :poster="videoThumbnail"
                  style="width: 100%"
                  playsinline
                  webkit-playsinline
                  x5-playsinline
                  x5-video-player-type="h5"
                  x5-video-player-fullscreen="true"
                  preload="metadata"
                  crossorigin="anonymous"
                  @click.prevent
                  controls
                ></video>
                <div v-if="!isMobile && showPlayButton" class="play-pause-overlay" @click="togglePlay">
                  <div class="play-pause-button">
                    <i :class="isPlaying ? 'fas fa-pause' : 'fas fa-play'"></i>
                  </div>
                </div>
              </div>
              
              <div class="facebook-actions">
                <button class="action-button">
                  <i class="far fa-thumbs-up"></i>
                  <span>Gefällt mir</span>
                </button>
                <button class="action-button">
                  <i class="far fa-comment"></i>
                  <span>Kommentieren</span>
                </button>
                <button class="action-button">
                  <i class="fas fa-share"></i>
                  <span>Teilen</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div>
          <button class="cancel-btn" @click="startEditingText" :disabled="post.status === 'rejected'" :style="{ cursor: post.status !== 'rejected' ? 'pointer' : 'auto', marginBottom: '10px' }">
            <i class="fas fa-edit"></i> Text bearbeiten
          </button>
          <br>
          <button class="cancel-btn" @click="showNote = true" :disabled="post.status === 'rejected'" :style="{ cursor: post.status !== 'rejected' ? 'pointer' : 'auto' }">
            Korrekturanfrage senden
          </button>
        </div>
      </div>
    </div>

    <!-- Text-Bearbeitungs-Modal -->
    <div class="modal-overlay" v-if="isEditingText">
      <div class="modal-content" style="position: relative">
        <button 
          class="close-button" 
          @click="cancelEditingText"
          :disabled="isSaving"
          :style="{ opacity: isSaving ? 0.5 : 1, cursor: isSaving ? 'not-allowed' : 'pointer' }"
        >
          <i class="fas fa-times"></i>
        </button>
        <h2>Text bearbeiten</h2>
        <textarea 
          v-model="editedText"
          class="text-edit-textarea"
          :style="{
            minHeight: '200px',
            fontFamily: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            padding: '15px',
            whiteSpace: 'pre-wrap',
            width: '100%',
            boxSizing: 'border-box',
            height: 'calc(100vh - 400px)',
            maxHeight: '600px'
          }"
          :disabled="isSaving"
          placeholder="Bearbeite hier den Text..."
        ></textarea>

        <div class="action-buttons">
          <button 
            class="cancel-btn" 
            @click="cancelEditingText"
            :disabled="isSaving"
          >
            Abbrechen
          </button>
          <button 
            class="approve-btn" 
            @click="saveEditedText"
            :disabled="isSaving"
          >
            <span v-if="!isSaving">Speichern</span>
            <span v-else class="loading-spinner"></span>
          </button>
        </div>
      </div>
    </div>

    <!-- Notiz-Modal -->
    <div class="modal-overlay" v-if="showNote">
      <div class="note-modal-content">
        <button class="close-button" @click="showNote = false">
          <i class="fas fa-times"></i>
        </button>
        <h2>
          Was soll geändert werden?
        </h2>
        <textarea style="padding: 15px; border-radius: 10px; font-family: 'Roboto'; font-size: 16px;" name="note" v-model="note" placeholder="Schreibe hier deine Notiz..." rows="5" required></textarea>

        <div class="action-buttons">
          <button class="cancel-btn" @click="showNote = false">Abbrechen</button>
          <button class="approve-btn" @click="rejectPost">Korrekturanfrage senden</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreviewModal',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    post: {
      type: Object,
      required: false,
      default: null,
      validator: (value) => {
        return value === null || typeof value === 'object';
      }
    }
  },
  watch: {
    post: {
      handler() {
        this.updatePlatformFlags();
      },
      deep: true
    },
    show: {
      handler(newVal) {
        if (newVal) {
          window.addEventListener('popstate', this.handlePopState);
          if (!this.isPopState) {
            history.pushState({ modal: true }, '');
          }
        } else {
          window.removeEventListener('popstate', this.handlePopState);
        }
      }
    },
    showNote: {
      handler(newVal) {
        if (newVal && !this.isPopState) {
          history.pushState({ noteModal: true }, '');
        }
      }
    },
    firstVideo: {
      immediate: true,
      async handler(newVal) {
        if (!newVal || !this.post || !this.post.metricoolPost) {
          this.videoThumbnail = '';
          return;
        }
        
        // Verwende das bereits generierte Thumbnail, falls vorhanden
        if (this.post.videoThumbnail) {
          this.videoThumbnail = this.post.videoThumbnail;
          return;
        }
        
        const milliseconds = this.post.metricoolPost.videoCoverMilliseconds;
        if (typeof milliseconds !== 'number') {
          this.videoThumbnail = '';
          return;
        }
        
        this.videoThumbnail = await this.generateThumbnail(newVal, milliseconds);
      }
    }
  },
  methods: {
    formatDateTime(dateString) {
      if (!dateString) return 'Nicht geplant';
      
      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
          return 'Ungültiges Datum';
        }
        
        return new Intl.DateTimeFormat('de-DE', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        }).format(date);
      } catch (error) {
        console.error('Datum Formatierungsfehler:', error);
        return 'Ungültiges Datum';
      }
    },
    rejectPost() {
      if (this.note !== "") {
        this.$emit('reject', this.post.postId, structuredClone(this.note));
        this.showNote = false;
        this.note = "";
      } else {
        alert('Du musst eine Notiz angeben.');
      }
    },
    updatePlatformFlags() {
      if (this.post) {
        if(this.post.networks.includes('facebook')){
          this.isFacebook = true;
          this.isInstagram = false;
          this.isTikTok = false;
        } else if (this.post.networks.includes('instagram')) {
          this.isFacebook = false;
          this.isInstagram = true;
          this.isTikTok = false;
        } else if (this.post.networks.includes('tiktok')) {
          this.isFacebook = false;
          this.isInstagram = false;
          this.isTikTok = true;
        }
      }
    },
    handlePopState() {
      this.isPopState = true;
      if (this.showNote) {
        this.showNote = false;
      } else if (this.show) {
        this.$emit('close');
      }
      this.$nextTick(() => {
        this.isPopState = false;
      });
    },
    togglePlay() {
      const video = this.$refs.videoPlayer;
      if (video) {
        if (video.paused) {
          video.play();
          this.isPlaying = true;
        } else {
          video.pause();
          this.isPlaying = false;
        }
      }
    },
    switchPlatform(platform) {
      // Reset video state
      this.isPlaying = false;
      
      // Switch platform
      if (platform === 'facebook') {
        this.isInstagram = false;
        this.isTikTok = false;
        this.isFacebook = true;
      } else if (platform === 'instagram') {
        this.isInstagram = true;
        this.isTikTok = false;
        this.isFacebook = false;
      } else if (platform === 'tiktok') {
        this.isTikTok = true;
        this.isInstagram = false;
        this.isFacebook = false;
      }

      // Pause any playing video
      const video = this.$refs.videoPlayer;
      if (video) {
        video.pause();
      }
    },
    handleResize() {
      // Trigger einer Neuberechnung von isMobile
      this.$forceUpdate();
    },
    nextSlide() {
      if (Array.isArray(this.post.metricoolPost.media)) {
        this.currentSlideIndex = (this.currentSlideIndex + 1) % this.post.metricoolPost.media.length;
      }
    },
    previousSlide() {
      if (Array.isArray(this.post.metricoolPost.media)) {
        this.currentSlideIndex = this.currentSlideIndex === 0 
          ? this.post.metricoolPost.media.length - 1 
          : this.currentSlideIndex - 1;
      }
    },
    startEditingText() {
      this.editedText = this.post.text;
      this.isEditingText = true;
    },
    async saveEditedText() {
      if (this.editedText === this.post.text) {
        this.isEditingText = false;
        return;
      }

      this.isSaving = true;
      try {
        // Warten auf die Fertigstellung des API-Calls in der übergeordneten Komponente
        await new Promise((resolve, reject) => {
          this.$emit('saveText', this.post.postId, this.editedText, { resolve, reject });
        });
        // eslint-disable-next-line
        this.post.text = this.editedText;
        this.isEditingText = false;
      } catch (error) {
        console.error('Fehler beim Speichern des Textes:', error);
        alert('Der Text konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.');
      } finally {
        this.isSaving = false;
      }
    },
    cancelEditingText() {
      if (this.isSaving) return;
      this.isEditingText = false;
      this.editedText = this.post.text;
    },
    async generateThumbnail(videoUrl, timeInMs) {
      if (!videoUrl || typeof timeInMs !== 'number' || timeInMs < 0) {
        return '';
      }

      // Cache-Key erstellen
      const cacheKey = `${videoUrl}_${timeInMs}`;
      
      // Prüfen ob Thumbnail im Cache ist
      if (this.thumbnailCache.has(cacheKey)) {
        return this.thumbnailCache.get(cacheKey);
      }
      
      try {
        // Erstelle ein temporäres Video-Element
        const video = document.createElement('video');
        video.crossOrigin = 'anonymous';
        video.src = videoUrl;
        video.currentTime = timeInMs / 1000;
        
        // Erstelle ein Canvas-Element mit reduzierter Größe
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d', { alpha: false }); // Alpha-Kanal deaktivieren für bessere Performance
        
        return new Promise((resolve) => {
          const handleSeeked = () => {
            try {
              if (!video.videoWidth || !video.videoHeight) {
                resolve('');
                return;
              }
              
              // Basis-Breite von 500px
              const targetWidth = 320;
              
              // Berechne neue Dimensionen basierend auf dem Video-Seitenverhältnis
              const videoRatio = video.videoWidth / video.videoHeight;
              const width = targetWidth;
              const height = width / videoRatio;
              
              canvas.width = width;
              canvas.height = height;
              
              // Zeichne das Bild mit optimierten Einstellungen
              context.imageSmoothingEnabled = true;
              context.imageSmoothingQuality = 'high';
              context.drawImage(video, 0, 0, width, height);
              
              // Konvertiere zu JPEG mit guter Qualität
              const thumbnail = canvas.toDataURL('image/jpeg', 0.70);
              
              // Speichere im Cache
              this.thumbnailCache.set(cacheKey, thumbnail);
              
              resolve(thumbnail);
            } catch (error) {
              console.error('Fehler beim Erstellen des Thumbnails:', error);
              resolve('');
            } finally {
              video.removeEventListener('seeked', handleSeeked);
            }
          };
          
          video.addEventListener('seeked', handleSeeked);
          
          video.addEventListener('error', (error) => {
            console.error('Fehler beim Laden des Videos:', error);
            resolve('');
          });
        });
      } catch (error) {
        console.error('Fehler in generateThumbnail:', error);
        return '';
      }
    },
    updateVideoTime() {
      const video = this.$refs.videoPlayer;
      if (video) {
        this.currentVideoTime = video.currentTime;
        this.videoDuration = video.duration || 0;
      }
    },
    formatVideoTime(seconds) {
      if (!isFinite(seconds)) return '0:00';
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = Math.floor(seconds % 60);
      return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
    },
  },
  created() {
    this.updatePlatformFlags();
  },
  mounted() {
    this.updatePlatformFlags();
    
    // Fügen Sie einen Event Listener für Größenänderungen hinzu
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    // Cache leeren beim Unmount
    this.thumbnailCache.clear();
    window.removeEventListener('popstate', this.handlePopState);
    window.removeEventListener('resize', this.handleResize);
  },
  data() {
    return {
      isFacebook: true,
      isInstagram: false,
      isTikTok: false,
      showNote: false,
      note: "",
      showNoteTooltip: false,
      customerNotes: "",
      isPopState: false,
      showPlayButton: false,
      isPlaying: false,
      currentSlideIndex: 0,
      isEditingText: false,
      editedText: "",
      isSaving: false,
      videoThumbnail: '',
      thumbnailCache: new Map(), // Cache für Thumbnails
      currentVideoTime: 0,
      videoDuration: 0,
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    },
    hasVideos() {
      if (!this.post || !this.post.metricoolPost || !Array.isArray(this.post.metricoolPost.media)) {
        return false;
      }
      return this.post.metricoolPost.media.some(url => url && url.includes('.mp4'));
    },
    firstVideo() {
      if (!this.post || !this.post.metricoolPost || !Array.isArray(this.post.metricoolPost.media)) {
        return '';
      }
      const video = this.post.metricoolPost.media.find(url => url && url.includes('.mp4'));
      return video || '';
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 60px 20px 60px 20px;
  border-radius: 8px;
  width: 600px;
  min-height: 700px;
  height: auto;
  max-height: 80vh;
  max-width: 800px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.note-modal-content {
  background: white;
  padding: 60px 20px 60px 20px;
  border-radius: 8px;
  width: 600px;
  height: auto;
  max-height: 80vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.platform-switch {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-bottom: 20px;
}

.platform-button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: #f0f2f5;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;
  color: #65676b;
}

.platform-button i {
  font-size: 20px;
  color: #65676b;
}

.platform-button.active {
  background: #1877f2;
  color: white;
}

.platform-button.active i {
  color: white;
}

/* Instagram button specific */
.instagram-button.active {
  background: #E1306C;
}

.instagram-button.active i {
  color: white;
}

/* TikTok button specific */
.tiktok-button.active {
  background: #000;
}

.tiktok-button.active i {
  color: white;
}

/* Remove old switch styles */
.switch, .slider {
  display: none;
}

.preview-container {
  flex: 1;
  margin: 10px auto;
  max-width: 400px;
  padding: 0px 20px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.post-header {
  padding: 10px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ddd;
}

.profile-pic {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ddd;
  margin-right: 10px;
}

.media-container img,
.media-container video {
  width: 100%;
  max-height: 500px;
  object-fit: contain;
}

.reel-container {
  position: relative;
  width: 100%;
}

.reel-indicator {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
}

.post-text {
  padding: 15px;
  white-space: pre-wrap;
}

.action-buttons {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}

.approve-btn,
.cancel-btn,
.reject-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  color: gray;
}

.approve-btn {
  color: white;
  background: #42b983;
}

.reject-btn {
  background: #dc3545;
}

.instagram-post {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 500px;
  margin: 20px auto 30px auto;
}

.post-header {
  padding: 8px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: none;
}

.profile-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.profile-pic {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
}

.username {
  font-size: 13px;
  font-weight: 600;
}

.more-options {
  font-weight: bold;
  letter-spacing: 1px;
  color: #262626;
}

.media-container {
  width: 100%;
  background: #fafafa;
}

.media-container img {
  width: 100%;
  height: auto;
  display: block;
}

.instagram-actions {
  padding: 8px 12px;
}

.action-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-actions {
  display: flex;
  gap: 16px;
}

.action-icon {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.action-icon i {
  font-size: 24px;
  color: #262626;
}

.post-info {
  padding: 0 12px 12px;
  display: flex;
  justify-content: flex-start;
  gap: 8px;
}

.post-reference {
  font-size: 13px;
  text-align: left;
  white-space: pre-wrap;
}

.facebook-post {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 500px;
  margin: 20px auto 30px auto;
}

.post-header {
  padding: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.profile-section {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-text {
  display: flex;
  flex-direction: column;
}

.page-name {
  font-weight: 600;
  font-size: 15px;
  color: #050505;
}

.post-meta {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #65676B;
  font-size: 13px;
}

.dot {
  font-size: 3px;
  margin: 0 4px;
}

.globe-icon {
  font-size: 12px;
}

.post-text {
  padding: 12px 16px;
  font-size: 15px;
  color: #050505;
  text-align: left;
}

.media-container {
  margin: 0;
}

.media-container img {
  width: 100%;
  display: block;
}

.video-container {
  position: relative;
}

.facebook-actions {
  display: flex;
  justify-content: space-around;
  padding: 4px 12px;
  margin-top: 12px;
  border-top: 1px solid #CED0D4;
}

.action-button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  background: none;
  border: none;
  border-radius: 4px;
  color: #65676b;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.action-button:hover {
  background-color: #F0F2F5;
  color: #1c1e21;
}

.action-button i {
  font-size: 18px;
  color: #65676b;
}

.more-options {
  color: #65676B;
  font-weight: bold;
  cursor: pointer;
}

.info-icon {
  position: relative;
  cursor: pointer;
  margin-left: 5px;
}

.tooltip {
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px;
  border-radius: 4px;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  white-space: pre-wrap;
  overflow-wrap: break-word;
  z-index: 10;
  width: 300px;
  text-align: left;
}

.close-button {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  color: #666;
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  z-index: 1002;
}

.close-button:hover {
  background-color: rgba(0, 0, 0, 0.1);
  color: #333;
}

.close-button i {
  color: #666;
}

/* Fügen Sie diese Media Queries hinzu */
@media screen and (max-width: 768px) {
  .modal-overlay {
    padding: 0;
    background: white;
    overflow-y: auto;
    display: block;
    width: 100vw; /* Viewport-Breite */
    max-width: 100vw; /* Maximale Viewport-Breite */
  }

  .modal-content,
  .note-modal-content {
    width: 100vw; /* Viewport-Breite */
    max-width: 100vw; /* Maximale Viewport-Breite */
    min-height: 100vh;
    height: auto;
    max-height: none;
    margin: 0;
    padding: 60px 20px 60px 20px;
    border-radius: 0;
    overflow-x: hidden; /* Verhindert horizontales Scrollen */
    position: relative;
    display: flex;
    flex-direction: column;
    box-sizing: border-box; /* Wichtig: Padding wird in Gesamtbreite einberechnet */
  }

  .preview-container {
    padding: 0;
    margin: 20px 0;
    width: 100%;
    max-width: 100%;
    height: auto;
    min-height: 200px;
    flex: 1;
    box-sizing: border-box;
  }

  .modal-content > div:last-child {
    margin: 20px 0;
    padding: 0;
    width: 100%;
    box-sizing: border-box;
  }

  .cancel-btn {
    width: 100%;
    margin: 0;
    padding: 15px;
    box-sizing: border-box;
    font-size: 14px; /* Kleinere Schrift für mobile */
  }

  .close-button {
    position: fixed;
    right: 10px;
    width: 30px;
    height: 30px;
    font-size: 20px;
    background: white;
    z-index: 1010;
  }

  .platform-switch {
    margin: 20px 0;
  }

  .action-buttons {
    margin: 20px 0;
    padding: 0;
    display: flex;
    gap: 10px;
    width: 100%;
    box-sizing: border-box;
  }

  .approve-btn,
  .reject-btn {
    flex: 1;
    margin: 0;
    padding: 15px;
    font-size: 14px;
    box-sizing: border-box;
  }

  .instagram-post,
  .facebook-post {
    margin: 10px 0;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .post-content {
    width: 100%;
    box-sizing: border-box;
  }
}

video {
  max-width: 100%;
  height: auto;
  background: #000;
}

/* Verstecken der Fullscreen-Schaltfläche (zusätzliche Sicherheit) */
video::-webkit-media-controls-fullscreen-button {
  display: none !important;
}

video::-webkit-media-controls-panel {
  display: flex !important;
  opacity: 1 !important;
}

.play-pause-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  opacity: 0;
  transition: opacity 0.2s ease;
  cursor: pointer;
}

.reel-container:hover .play-pause-overlay {
  opacity: 1;
}

.play-pause-button {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 24px;
  transition: transform 0.2s ease;
}

.play-pause-button:hover {
  transform: scale(1.1);
}

.play-pause-button i {
  color: white;
  margin-left: 4px; /* Für bessere optische Zentrierung des Play-Icons */
}

.play-pause-button i.fa-pause {
  margin-left: 0; /* Zurücksetzen für Pause-Icon */
}

/* Verstecken der Standard-Video-Controls */
video::-webkit-media-controls {
  display: flex !important;
  opacity: 1 !important;
}

/* Spezifische Android-Anpassungen */
@media screen and (max-width: 768px) {
  video::-webkit-media-controls-panel {
    display: flex !important;
    opacity: 1 !important;
  }
  
  .play-pause-overlay {
    display: none !important;
  }
}

.tiktok-post {
  width: 100%;
  height: 100%;
  background: black;
  position: relative;
}

.tiktok-content {
  position: relative;
  width: 100%;
  height: calc(100vh - 200px);
  max-height: 800px;
}

.tiktok-video-container {
  position: relative;
  width: 100%;
  height: 100%;
  background: black;
}

.tiktok-video-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.tiktok-video-container .play-pause-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
  opacity: 0;
  transition: opacity 0.2s ease;
  cursor: pointer;
  z-index: 20; /* Höherer z-index als tiktok-overlay */
}

.tiktok-video-container:hover .play-pause-overlay {
  opacity: 1;
}

.tiktok-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: white;
  padding: 20px;
  z-index: 10;
}

.tiktok-sidebar {
  position: absolute;
  right: 15px;
  bottom: 100px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.tiktok-action {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.tiktok-action i {
  font-size: 28px;
  color: white;
}

.tiktok-action span {
  font-size: 12px;
  color: white;
}

.tiktok-bottom {
  position: absolute;
  bottom: 20px;
  left: 20px;
  right: 0;
  margin-bottom: 20px;
  text-align: left;
}

.tiktok-username {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 8px;
  display: block;
}

.tiktok-description {
  font-size: 14px;
  margin-top: 8px;
}

.tiktok-top {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 20px;
}

.tiktok-tabs {
  display: flex;
  justify-content: center;
  gap: 30px;
  color: white;
  font-size: 17px;
}

.tiktok-tabs span {
  opacity: 0.7;
}

.tiktok-tabs span.active {
  opacity: 1;
  font-weight: bold;
}

.slideshow {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.slide-container {
  position: relative;
  width: 100%;
}

.slide-container img,
.slide-container video {
  display: none;
  width: 100%;
  height: auto;
}

.slide-container img.active,
.slide-container video.active {
  display: block;
}

.slide-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.8);
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
}

.slide-nav.prev {
  left: 10px;
}

.slide-nav.next {
  right: 10px;
}

.slide-dots {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 4px;
  z-index: 2;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
}

.dot.active {
  background: #0095f6;
}

.media-grid {
  display: grid;
  gap: 4px;
  width: 100%;
  background: #fff;
  padding: 2px;
}

.grid-item {
  position: relative;
  aspect-ratio: 1;
  overflow: hidden;
  background: #000;
}

.grid-item img,
.grid-item video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.grid-item.large {
  aspect-ratio: auto;
}

.grid-item.large img,
.grid-item.large video {
  object-fit: contain;
  max-height: 600px;
  width: 100%;
  height: auto;
}

/* Grid Layouts */
.media-grid.grid-1 {
  grid-template-columns: 1fr;
  background: transparent;
  padding: 0;
  gap: 0;
}

.media-grid.grid-2 {
  grid-template-columns: 1fr 1fr;
}

.media-grid.grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.media-grid.grid-4 {
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
}

.media-grid.grid-5 {
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, 1fr);
}

.media-grid.grid-5 .grid-item:first-child {
  grid-column: span 2;
}

.media-grid.grid-6 {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
}

@media screen and (max-width: 768px) {
  .media-grid {
    gap: 2px;
    padding: 1px;
  }
  
  .grid-item.large img,
  .grid-item.large video {
    max-height: 400px;
  }
}

.video-slide {
  display: none;
  position: relative;
  width: 100%;
}

.video-slide.active {
  display: block;
}

.video-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.video-slide video,
.video-container video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.video-slide .play-pause-overlay,
.video-container .play-pause-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
  opacity: 0;
  transition: opacity 0.2s ease;
  cursor: pointer;
}

.video-slide:hover .play-pause-overlay,
.video-container:hover .play-pause-overlay {
  opacity: 1;
}

.text-edit-container {
  position: relative;
  width: 100%;
}

.text-display {
  position: relative;
  padding-right: 40px;
}

.edit-text-btn {
  background: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  cursor: pointer;
  font-weight: bold;
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background-color 0.2s ease;
}

.edit-text-btn:hover:not(:disabled) {
  background: #357abd;
}

.edit-text-btn:disabled {
  background: #cccccc;
  cursor: not-allowed;
}

.edit-text-btn i {
  font-size: 16px;
}

.text-edit-textarea {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 8px;
  resize: vertical;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.text-edit-textarea:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
}

.text-edit-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.text-edit-cancel,
.text-edit-save {
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.text-edit-cancel {
  background: none;
  border: 1px solid #ddd;
  color: #65676b;
}

.text-edit-cancel:hover {
  background: #f0f2f5;
}

.text-edit-save {
  background: #0095f6;
  border: none;
  color: white;
  min-width: 80px;
}

.text-edit-save:hover:not(:disabled) {
  background: #1877f2;
}

.text-edit-save:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 0.8s linear infinite;
}
</style> 